import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-dce88de0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "flex tab mt20 mb30"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  class: "flex_FSBC"
};
const _hoisted_4 = {
  class: "item_title"
};
const _hoisted_5 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.list, (item, index) => {
    return _openBlock(), _createElementBlock("p", {
      class: _normalizeClass(['tab_item', 'pointer', index == $setup.data.tabsIndex && 'text_blue']),
      onClick: () => $setup.changeTabs(index),
      key: index
    }, _toDisplayString(item.label), 11, _hoisted_2);
  }), 128))]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.list[$setup.data.tabsIndex].items, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "mt15 item",
      key: index
    }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("p", _hoisted_4, _toDisplayString(item.label), 1), _createVNode(_component_el_button, {
      type: "primary",
      onClick: () => $setup.setTargetView(index)
    }, {
      default: _withCtx(() => [_createTextVNode("查看")]),
      _: 2
    }, 1032, ["onClick"])]), item.view ? (_openBlock(), _createElementBlock("iframe", {
      key: 0,
      class: "iframe mt20",
      src: item.src
    }, null, 8, _hoisted_5)) : _createCommentVNode("", true)]);
  }), 128))]);
}